'use client';

import { AD_EMPTY_EVENT } from '@fe-cnyes/fe-dfp';
import LiTV from '@fe-news/components/LiTV';
import DesktopAdProfiles from '@fe-news/constants/DFP/DesktopAdProfiles';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

const AdSlot = dynamic(() => import('@fe-news/components/DynamicAd/BaseDynamicAd'), {
  loading: () => null,
  ssr: false
});

const LITV_CONTAINER = 239;

const ToggleTopAd = ({
  isShowLiTV = false,
  setIsDisplayLiTV
}: {
  isShowLiTV?: boolean;
  setIsDisplayLiTV?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  useEffect(() => {
    const handleRenderedEvent = (adRenderEnd: Event) => {
      const slotId = `div-gpt-ad-${DesktopAdProfiles.idleBannerCenter.name}`;

      if ((adRenderEnd as CustomEvent).detail === slotId && setIsDisplayLiTV) {
        setIsDisplayLiTV(true);
      }
    };

    window.addEventListener(AD_EMPTY_EVENT, handleRenderedEvent);

    return () => {
      window.removeEventListener(AD_EMPTY_EVENT, handleRenderedEvent);
    };
  }, [setIsDisplayLiTV]);

  if (isShowLiTV) return <LiTV litvId='ppn-Y3kz|Y3k=-0' containerStyle={{ margin: 0, height: LITV_CONTAINER }} />;

  return <AdSlot key='interested-sponsor-ad-2' profile={DesktopAdProfiles.idleBannerCenter} />;
};

export default ToggleTopAd;
